import { apiFetch, apiAction, oneTimeAction } from 'utils';

import * as constants from '../constants/index';

export const getTokens = (tokenType) => {
  const actionKey = [constants.BEGIN_GETTING_TOKENS, tokenType || '*'].join('_');

  return oneTimeAction(actionKey, (dispatch, getState) => {
    const state = getState();

    if (state.tokensByType && state.tokensByType[tokenType || '*']) {
      return Promise.resolve({
        tokens: state.tokensByType[tokenType || '*']
      });
    }

    return dispatch(apiAction(constants.BEGIN_GETTING_TOKENS, constants.SUCCESS_GETTING_TOKENS, constants.ERROR_GETTING_TOKENS,
      (state) =>
        tokenType
          ? apiFetch.post(
          state,
          `tokens`,
          {
            type: tokenType
          }
        )
          : apiFetch.get(
          state,
          `tokens`
        ),
      {tokenType}
    ));
  });
};
